export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Always Improving',
  headline: 'About Me',
  description:
    'I am a accomplished IT professional with a specializing in software development, with additional expertise in data science and foundational information security. I hold a diploma in Computer Programming & Analysis from Fanshawe College and certifications in CompTIA Network+, Security+, and Foundations of Data Science from the University of Waterloo, equipping me with a versatile and well-rounded skill set. My expertise includes data analysis, object-oriented programming, and networking, complemented by hands-on experience with tools like Tableau to create visually engaging and interactive performance reports. Currently, I am advancing my knowledge by pursuing the Blue Team Level 1 (BTL1) and CCNA certifications.',
  buttonLabel: 'Get Started',
  imgStart: false,
  img: require('../../images/About Me V3.png'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false,
  image: require('../../images/About Me V1.png')
};

export const homeObjTwo = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Unlimited Access',
  headline: 'Login to your account at any time',
  description:
    'We have you covered no matter where you are located. All you need is an internet connection and a phone or computer.',
  buttonLabel: 'Learn More',
  imgStart: true,
  img: require('../../images/svg-2.svg'),
  alt: 'Piggybank',
  dark: false,
  primary: false,
  darkText: true
};

export const homeObjThree = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Join our Team',
  headline: 'Creating an account is extremely easy',
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
  buttonLabel: 'Start Now',
  imgStart: false,
  img: require('../../images/svg-3.svg'),
  alt: 'Papers',
  dark: false,
  primary: false,
  darkText: true,
  image: require('../../images/About PNG-1.png')
};
